import { IconWithTooltip } from '../../../Icon'

import InfoIcon from '../../../../icons/info.svg'

function DocFlowTableCellInfoIcon({ content, placement }) {
  return (
    <IconWithTooltip
      Icon={InfoIcon}
      tooltip={content}
      tooltipPlacement={placement}
    />
  )
}

export default DocFlowTableCellInfoIcon
